<template>
  <div id="rewards">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <h1>Features</h1>
      </v-row>
    </v-container>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="4" md="8">
          <v-card dark>
            <v-card-text>
              <v-list>
                <v-list-item v-for="item in features" :key="item.id">
                  <v-list-item-content>
                    <v-switch
                      v-model="item.enabled"
                      :label="`${item.display_name}`"
                      @click.stop="toggle(item.feature)"
                    ></v-switch>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, axios);

axios.defaults.baseURL = process.env.VUE_APP_BASEAPI;

export default {
  name: "Features",
  data() {
    return {
      features: {}
    };
  },
  mounted() {
    this.getFeatures();
  },
  computed: {},
  methods: {
    getFeatures() {
      this.$store.dispatch("retrieveAdminFeatures").then(() => {
        this.features = this.$store.getters.adminFeatures;
      });
    },
    toggle(feature) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");
      Vue.axios
        .post("features/toggle", {
            feature: feature
        }) 
        .then(response => {   
             
          for(var i = 0; i < this.features.length; i++) {
              if(this.features[i].feature == feature) {
                  this.features[i].enabled = response.data.data.enabled;
                  break;
              }
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
.container.fill-height > .row {
  max-width: initial;
}
</style>